import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-900">
      <div className="w-full px-4 md:px-6">
        <div className="py-12 md:py-16">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <Link to="/" className="flex items-center gap-2 mb-4">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-movie-2-line text-xl text-primary-400"></i>
                </div>
                <span className="font-heading text-lg font-bold text-white">悟空影视</span>
              </Link>
              <p className="text-sm text-foreground-400 leading-relaxed">
                海量高清影视资源，无需注册，即点即播。悟空影视致力于为每一位影迷提供最便捷、最流畅的免费在线观影体验。
              </p>
            </div>

            <div>
              <h3 className="font-heading text-sm font-semibold text-white mb-4">快速导航</h3>
              <ul className="space-y-2">
                <li><Link to="/" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">首页</Link></li>
                <li><Link to="/category/movie" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">电影</Link></li>
                <li><Link to="/category/tv" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">电视剧</Link></li>
                <li><Link to="/category/anime" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">动漫</Link></li>
                <li><Link to="/category/variety" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">综艺</Link></li>
              </ul>
            </div>

            <div>
              <h3 className="font-heading text-sm font-semibold text-white mb-4">热门推荐</h3>
              <ul className="space-y-2">
                <li><Link to="/article/1" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">流浪地球3</Link></li>
                <li><Link to="/article/2" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">繁花</Link></li>
                <li><Link to="/article/4" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">鬼灭之刃</Link></li>
                <li><Link to="/article/5" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">狂飙</Link></li>
                <li><Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">关于我们</Link></li>
              </ul>
            </div>

            <div>
              <h3 className="font-heading text-sm font-semibold text-white mb-4">联系我们</h3>
              <ul className="space-y-3">
                <li className="flex items-start gap-2">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-mail-line text-sm text-foreground-400"></i>
                  </div>
                  <span className="text-sm text-foreground-400">service@wukongyingshi.com</span>
                </li>
                <li className="flex items-start gap-2">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-phone-line text-sm text-foreground-400"></i>
                  </div>
                  <span className="text-sm text-foreground-400">400-888-0000</span>
                </li>
                <li className="flex items-start gap-2">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-map-pin-line text-sm text-foreground-400"></i>
                  </div>
                  <span className="text-sm text-foreground-400">北京市朝阳区光华路8号</span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="border-t border-foreground-800/30 py-6">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              &copy; {new Date().getFullYear()} 悟空影视 wukongyingshi.com 版权所有
            </p>
            <div className="flex items-center gap-6">
              <span className="text-xs text-foreground-500 hover:text-foreground-400 transition-colors cursor-pointer whitespace-nowrap">用户协议</span>
              <span className="text-xs text-foreground-500 hover:text-foreground-400 transition-colors cursor-pointer whitespace-nowrap">隐私政策</span>
              <span className="text-xs text-foreground-500 hover:text-foreground-400 transition-colors cursor-pointer whitespace-nowrap">免责声明</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}